<script>
import IconX from "@js/components/Icons/IconX.vue";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import {Link} from "@inertiajs/vue3";
import IconShare from "@js/components/Icons/IconShare.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";
import IconChatFilled from "../Icons/IconChatFilled.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";
import {useJivoStore} from "@js/store/JivoStore.js";
import {contacts} from "@js/company_details.ts";
import {checkDocument} from "@js/helpers.ts";

export default {
    name: "SpeedDial",
    components: {IconChatFilled, IconTelegram, IconWhatsApp, IconShare, IconPhone, IconX, Link},
    data() {
        return {
            icon_cycles: {
                chat: 1,
                whatsapp: 2,
                telegram: 3,
                callback: 4,
            },
            active_icon: 1,
            interval: null,
        }
    },
    methods: {
        share() {
            if (checkDocument() && typeof navigator.share !== 'undefined') {
                navigator.share({
                    title: this.$page.props.title,
                    text: this.$page.props.description,
                    url: window.location.href
                })
            } else {
                this.copy()
            }
        },
    },
    mounted() {
        const vm = this
        this.interval = setInterval(function () {
            const cycleValues = Object.values(vm.icon_cycles);
            const idx = cycleValues.indexOf(vm.active_icon);
            vm.active_icon = cycleValues[(idx + 1) % cycleValues.length];
        }, 4000)
    },
    beforeUnmount() {
        clearTimeout(this.interval)
    },
    setup() {
        const callbackStore = useCallbackStore()
        const themeStore = useThemeStore()
        const jivoStore = useJivoStore()

        return {callbackStore, themeStore, jivoStore, contacts}
    }
}
</script>

<template>
    <div data-dial-init class="group fixed end-6 bottom-6 z-2">
        <div id="speed-dial-menu-default" class="flex flex-col items-center hidden mb-4 space-y-2">
            <!--Поделиться-->
            <button @click.prevent="share" aria-label="Поделиться"
                    type="button" data-tooltip-target="tooltip-share" data-tooltip-placement="left"
                    class="flex justify-center items-center w-[52px] h-[52px] text-gray-700 md:hover:text-gray-900 bg-white rounded-full border border-gray-200 md:hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
                <IconShare class="w-5 h-5"/>
            </button>
            <div id="tooltip-share" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-[#3a4250] rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                Поделиться
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--Поделиться-->
            <!--WhatsApp-->
            <a :href="contacts.whatsapp"
               target="_blank" type="button" data-tooltip-target="tooltip-wa" data-tooltip-placement="left"
               class="flex justify-center items-center w-[52px] h-[52px] text-gray-500 md:hover:text-gray-900 bg-white rounded-full border border-gray-200 shadow-sm md:hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
                <IconWhatsApp class="w-6 h-6 text-whatsapp"/>
            </a>
            <div id="tooltip-wa" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-[#3a4250] rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                WhatsApp
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--WhatsApp-->
            <!--Telegram-->
            <a :href="contacts.telegram"
               target="_blank" type="button" data-tooltip-target="tooltip-telegram" data-tooltip-placement="left"
               class="flex justify-center items-center w-[52px] h-[52px] text-gray-500 md:hover:text-gray-900 bg-white rounded-full border border-gray-200 shadow-sm md:hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
                <IconTelegram class="w-5 h-5 -ms-0.5 text-telegram"/>
            </a>
            <div id="tooltip-telegram" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-[#3a4250] rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                Telegram
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--Telegram-->
            <!--Звонок-->
            <button @click.prevent="callbackStore.showBaseCallbackPopup" aria-label="Звонок"
                    type="button" data-tooltip-target="tooltip-callback" data-tooltip-placement="left"
                    class="group flex justify-center items-center w-[52px] h-[52px] bg-white rounded-full border border-gray-200 shadow-sm md:hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
                <IconPhone class="w-7 h-7 text-gray-700 group-hover:text-gray-900"/>
            </button>
            <div id="tooltip-callback" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-[#3a4250] rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                Обратный звонок
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--Звонок-->
            <!--Чат-->
            <button @click.prevent="jivoStore.openJivoChat" aria-label="Чат"
                    type="button" data-tooltip-target="tooltip-chat" data-tooltip-placement="left"
                    class="group relative flex justify-center items-center w-[52px] h-[52px] bg-white rounded-full border border-gray-200 shadow-sm md:hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 focus:outline-none">
                <IconChatFilled class="w-6 h-6 text-gray-700 group-hover:text-gray-900"/>
                <span class="absolute top-0 end-1"
                      v-if="jivoStore.hasUnreadMessages">
                    <span class="relative flex size-3">
                        <span
                            class="absolute inline-flex h-full w-full animate-ping rounded-full bg-navHoverColor opacity-75"></span>
                        <span class="relative inline-flex size-3 rounded-full bg-navHoverColor"></span>
                    </span>
                </span>
            </button>
            <div id="tooltip-chat" role="tooltip"
                 class="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-[#3a4250] rounded-lg shadow-sm opacity-0 tooltip text-nowrap">
                Онлайн-чат
                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            <!--Чат-->
        </div>
        <button type="button" data-dial-toggle="speed-dial-menu-default" aria-controls="speed-dial-menu-default"
                aria-expanded="false" aria-label="Быстрое меню"
                :class="{
            'bg-whatsapp': active_icon === icon_cycles.whatsapp,
            'bg-telegram': active_icon === icon_cycles.telegram,
            'bg-baseColor': active_icon === icon_cycles.chat,
                }"
                class="group flex items-center justify-center bg-baseColor rounded-full w-14 h-14 focus:outline-none transition">
            <transition name="icon-fade" mode="out-in">
                <IconWhatsApp v-if="active_icon === icon_cycles.whatsapp"
                              :key="'sdkey_' + icon_cycles.whatsapp"
                              class="w-6 h-6 text-white"/>
                <IconTelegram v-else-if="active_icon === icon_cycles.telegram"
                              :key="'sdkey_' + icon_cycles.telegram"
                              class="w-5 h-5 -ms-0.5 text-white"/>
                <IconChatFilled v-else-if="active_icon === icon_cycles.chat"
                                :key="'sdkey_' + icon_cycles.chat"
                                class="w-6 h-6 -ms-0.5 text-black"/>
                <IconPhone v-else
                           :key="'sdkey_' + icon_cycles.callback"
                           class="w-7 h-7 text-black"/>
            </transition>
            <span class="absolute top-0 end-1 group-hover:hidden"
                  v-if="jivoStore.hasUnreadMessages">
                <span class="relative flex size-3">
                    <span
                        class="absolute inline-flex h-full w-full animate-ping rounded-full bg-navHoverColor opacity-75"></span>
                    <span class="relative inline-flex size-3 rounded-full bg-navHoverColor"></span>
                </span>
            </span>
        </button>
        <!--        <ScrollUp/>-->
    </div>
</template>

<style scoped lang="scss">
.z-2 {
    z-index: 2;
}

/* анимация фейд+масштаб */
.icon-fade-enter-active,
.icon-fade-leave-active {
    transition: opacity 0.4s ease, transform 0.4s ease;
}

.icon-fade-enter-from,
.icon-fade-leave-to {
    opacity: 0;
    transform: scale(0.8);
}

.icon-fade-enter-to,
.icon-fade-leave-from {
    opacity: 1;
    transform: scale(1);
}
</style>
